import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { I18nProvider } from '../_metronic/i18n/i18nProvider';
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core';
import { MasterInit } from '../_metronic/layout/MasterInit';
import { AuthInit } from './modules/auth';
import { useAxiosLoader } from './modules/loadingAxios/loading';
import Spinner from './modules/custom/Spinner/Spinner';
import { store } from '../redux/store';
import { Provider } from 'react-redux';
 
const App: React.FC = () => {
  const [loading] = useAxiosLoader();

  return (
    <Provider store={store}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <I18nProvider>
          <LayoutProvider>
            <AuthInit>
              {/* <ThemeToggle /> */}
              <Outlet />
              <MasterInit />
              {loading && <Spinner />}
            </AuthInit>
          </LayoutProvider>
        </I18nProvider>
      </Suspense>
    </Provider>
  );
};

export { App };